import { DESCRIPTION_FIELD, DESC_KEYS } from '@/constants/calendar';
import { CalendarTime } from '@/store/calendarStore';
import axios from 'axios';
import dayjs from 'dayjs';

const getPresignedUrl = async (filePath: string) => {
  const response = await axios.post(
    `${process.env.REACT_APP_CALENDAR_API_URL}/presigned-urls`,
    {
      key: filePath,
    },
    {
      withCredentials: true,
    }
  );

  return response.data.preSignedUrl;
};

const uploadFileToS3 = async (file: File, url: string) => {
  const response = await axios.put(url, file, {
    headers: {
      'Content-Type': file.type,
    },
  });

  return response;
};

const makeDescriptionJSon = (data, speakers) => {
  const { description } = data;
  const descriptionString = DESCRIPTION_FIELD.map(field => {
    if (field === DESCRIPTION_FIELD[6]) {
      return `${field}: ${speakers.map(speaker => `${speaker}`).join(', ')}`;
    }

    const descKey = Object.entries(DESC_KEYS).find(
      ([key, value]) => value === field
    );
    if (!descKey) return `${field}: ${description[field]}`;

    const key = descKey[0];
    const value = description[key] || '';

    return `${field}: ${value}`;
  }).join('\n');

  const jsonString = `${descriptionString}`;
  return jsonString;
};

const makeEventForm = (data, speakers) => {
  const jsonString = makeDescriptionJSon(data, speakers);
  const endDate = new Date(data.end);
  endDate.setDate(endDate.getDate() + 1);

  const event = {
    summary: data.summary,
    location: data.location,
    description: jsonString,
    start: data.isAllday
      ? {
          date: data.start,
        }
      : {
          dateTime: `${data.start}:00`,
          timeZone: data.timeZone,
        },
    end: data.isAllday
      ? {
          date: endDate.toISOString().split('T')[0],
        }
      : {
          dateTime: `${data.end}:00`,
          timeZone: data.timeZone,
        },
  };
  return event;
};

const makeFileName = (key: string, origin: string) => {
  const extension = origin.split('.').pop();

  return `${key}.${extension}`;
};

const uploadFile = async (key: string, file: File) => {
  const uploadUrl = await getPresignedUrl(key);
  const response = await uploadFileToS3(file, uploadUrl);
  return response;
};

const deleteFile = async (key: string) => {
  const response = await axios.delete(
    `${process.env.REACT_APP_CALENDAR_API_URL}/files/${key}`
  );

  return response;
};

const getFormattedDate = (date: CalendarTime, type: string) => {
  const isAllday = !!date.date;
  let formattedDate: any = isAllday ? dayjs(date.date) : dayjs(date.dateTime);

  if (isAllday) {
    if (type === 'end') {
      formattedDate = formattedDate.subtract(1, 'day');
    }
    formattedDate = formattedDate.format('YYYY-MM-DD');
  } else {
    formattedDate = formattedDate.format('YYYY-MM-DDTHH:mm');
  }

  return formattedDate;
};

export {
  getFormattedDate,
  makeFileName,
  makeEventForm,
  uploadFile,
  uploadFileToS3,
  deleteFile,
  getPresignedUrl,
};
